<template>
  <div class="Column_management">

    <el-form style="background-color:#fff;padding:20px" :inline="true" class="demo-form-inline">
      <el-form-item label="综合查询">
        <el-input v-model="Name" placeholder="请输入栏目名称、栏目代号"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">查询</el-button>
        <el-button type="primary" @click="resetfun()">重置</el-button>
      </el-form-item>
    </el-form>

    <div class="Column_management_div">
      <el-button style="margin-left: 20px;margin-top:20px;" @click="addColumn()" type="primary">新增栏目</el-button>
      
      <el-table :data="tableData1" style="width: 98%;margin-left: 1%;margin-top:20px" row-key="value"  border lazy :load="load" :tree-props="{ children: 'children', hasChildren: 'fuzi'}">
        <el-table-column prop="ItemLevel" label="栏目级别"></el-table-column>
        <el-table-column prop="LineNumber" label="栏目排序"></el-table-column>
        <el-table-column prop="ItemCode" label="栏目代号"></el-table-column>
        <el-table-column prop="label" label="栏目名称"></el-table-column>
        <!-- <el-table-column prop="value" label="value"></el-table-column>-->
        <el-table-column prop="CreateTime" label="创建时间"></el-table-column>
        <el-table-column label="启用" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.IsActive == '1' ? '启用' : '不启用' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" show-load-tooltip>
          <template slot-scope="scope">
            <span class="w" style="margin-left:10px" @click="xgfun(scope.row)">修改</span>
            <span class="w" @click="delfun(scope.row)">删除</span>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination style="margin-top: 20px;text-align:right" @current-change="handleCurrentChange" :current-page.sync="pageIndex" :page-size="pageSize" layout="total, prev, pager, next" :total="UndoCount"></el-pagination>
      
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      a1: '',
      tableData1: [],
      pageSize: 10,
      pageIndex: 1,
      UndoCount: 0,
      Name:'',
    }
  },
  mounted() {
    this.getdata();
  },
  methods: {
    xgfun(ridow) {
      this.$router.push({
        path: '/propagate/edit_Column',
        query: { id: ridow.value },
      })
    },
    delfun(row) {
      this.$Http_Post('management/delColumnManagement', { ItemKey: row.value,}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.Global.request_successful(res.Message);
          this.$router.go(0);
        } else {
          this.Global.request_failure(res.Message);
        }
      })
    },
    resetfun() {
      this.Name = '';
      this.pageIndex = 1;
      this.getdata();
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getdata();
    },
    getdata() {
      this.$Http_Post('management/getColumnManagementByNode', { PItemKey: '0', pageIndex: this.pageIndex,pageSize: "10",Type:1,RoleID:sessionStorage.getItem('RoleID')}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.tableData1 = res.Data;
          this.UndoCount = res.Counts;
        } else {
          this.Global.request_failure(res.Message);
        }
      })
    },
    load(tree, treeNode, resolve) {
      if (tree.fuzi) {
        setTimeout(() => {
          this.$Http_Post('management/getColumnManagementByNode', { Name:"", PItemKey: tree.value, pageIndex: "1", pageSize: "10000", Type: 1,RoleID:sessionStorage.getItem('RoleID')}).then((res) => {
            if (res.Code == 200 || res.Code == 0) {
              if (res.Data) {
                resolve(res.Data);
              }
            } else {
              this.Global.request_failure(res.Message);
            }
          })
        }, 1000)
      }
    },
    onSubmit() {
      this.$Http_Post('management/getColumnManagementByNode', { Name:this.Name ,PItemKey: '0', pageIndex: "1", pageSize: "10", Type: 1,RoleID:sessionStorage.getItem('RoleID')}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.tableData1 = res.Data;
          this.UndoCount = res.Counts
        } else {
          this.Global.request_failure(res.Message);
        }
      })
    },
    addColumn() {//新增跳转
      this.$router.push('/propagate/add_Column');
    }
  },
}
</script>
<style>
.Column_management{width: 100%;height: 100%;background-color: rgb(233 233 233);}
.Column_management_div {width: 100%;height: calc(100% - 130px);background-color: #fff;margin-top: 20px;overflow: auto;}
.Column_management .el-table--enable-row-transition .el-table__body td{text-align: center;}
</style>
